function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 80,
  r: 80,
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 133.025V52C20 45.3726 25.3726 40 32 40H128C134.627 40 140 45.3726 140 52V128.087C125.738 147.489 103.286 160 78.0328 160C54.9923 160 34.2841 149.586 20 133.025Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 104,
  width: 80,
  height: 12,
  rx: 4,
  fill: "#6CB52D",
  fillOpacity: 0.53
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 59,
  width: 80,
  height: 12,
  rx: 4,
  fill: "#078DC5",
  fillOpacity: 0.58
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 80,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 80,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 104,
  y: 80,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 104,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 80,
  y1: 0,
  x2: 80,
  y2: 160,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F1F4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CBD7EB",
  stopOpacity: 0
})));

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.0d88a053.svg";
export { ForwardRef as ReactComponent };